var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
import avatar from "./assets/avatar-icon.svg";
import errorIcon from "./assets/live-chat-error-icon.svg";
var LIVE_CHAT_MODULE_ASSETS_MAP = {
  LIVE_CHAT_AVATAR: avatar,
  LIVE_CHAT_ERROR_ICON: errorIcon
};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(LIVE_CHAT_MODULE_ASSETS_MAP);
};

// src/live-chat.config.ts
var liveChatConfig;
var leagueLiveChat = {
  config(config) {
    if (!config)
      throw new Error("Live Chat: You must provide a config");
    liveChatConfig = config;
  },
  getConfig() {
    if (!liveChatConfig) {
      throw new Error("Live Chat: Configuration is not defined.");
    }
    if (!liveChatConfig.liveChatClient) {
      throw new Error("Live Chat: Configuration is missing liveChatClient");
    }
    return liveChatConfig;
  }
};

// src/live-chat-contract.types.ts
var EventTypes = /* @__PURE__ */ ((EventTypes2) => {
  EventTypes2["CHAT_STARTED"] = "ChatStarted";
  EventTypes2["CHAT_ENDED"] = "ChatEnded";
  EventTypes2["CHAT_RECONNECTED"] = "ChatReconnected";
  EventTypes2["END_CHAT"] = "EndChat";
  EventTypes2["EVENT_ACKNOWLEDGED"] = "EventAcknowledged";
  EventTypes2["ERROR_RECEIVED"] = "ErrorReceived";
  EventTypes2["MESSAGE"] = "Message";
  EventTypes2["PARTICIPANT_JOINED"] = "ParticipantJoined";
  EventTypes2["PARTICIPANT_LEFT"] = "ParticipantLeft";
  EventTypes2["PARTICIPANT_TYPING"] = "ParticipantTyping";
  EventTypes2["START_CHAT"] = "StartChat";
  EventTypes2["TRANSFER_REQUESTED"] = "TransferRequested";
  EventTypes2["WAITING_ROOM"] = "WaitingRoom";
  return EventTypes2;
})(EventTypes || {});
var ErrorTypes = /* @__PURE__ */ ((ErrorTypes2) => {
  ErrorTypes2["MESSAGE_FAILED"] = "MessageFailed";
  ErrorTypes2["DEFAULT"] = "Default";
  return ErrorTypes2;
})(ErrorTypes || {});
var ChatEndedReasonTypes = /* @__PURE__ */ ((ChatEndedReasonTypes2) => {
  ChatEndedReasonTypes2["INITIAL"] = "";
  ChatEndedReasonTypes2["AGENT_DISCONNECTED"] = "AGENT_DISCONNECTED";
  ChatEndedReasonTypes2["USER_DISCONNECTED"] = "USER_DISCONNECTED";
  ChatEndedReasonTypes2["CONNECTION_LOST"] = "CONNECTION_LOST";
  ChatEndedReasonTypes2["CHAT_UNAVAILABLE"] = "CHAT_UNAVAILABLE";
  return ChatEndedReasonTypes2;
})(ChatEndedReasonTypes || {});

// src/live-chat.routes.tsx
import React18 from "react";
import { Switch, Route } from "@leagueplatform/routing";

// src/pages/live-chat-landing.page.tsx
import React17, { useEffect as useEffect7, useState as useState3 } from "react";
import { Box as Box14, Spinner as Spinner2 } from "@leagueplatform/genesis-core";
import { ErrorState as ErrorState2 } from "@leagueplatform/web-common-components";

// src/components/live-chat-core/live-chat-core.component.tsx
import React16, { useEffect as useEffect6 } from "react";

// src/utils/live-chat-machine.utils.ts
import { createMachine } from "xstate";
import { v4 as uuidv4 } from "uuid";
var createLiveChatMachine = (client) => createMachine(
  {
    id: "liveChat",
    initial: "idle",
    predictableActionArguments: true,
    context: {
      client,
      chatEndedReason: {
        type: "" /* INITIAL */
      },
      toastErrors: [],
      messagingWindowEvents: [],
      failedMessagesEventIds: [],
      chips: [],
      queueTitle: "",
      queueDescription: ""
    },
    on: {
      ERROR_RECEIVED: { actions: ["errorReceived"] },
      CLEAR_ERROR: { actions: ["clearError"] }
    },
    states: {
      idle: {
        on: {
          START_CHAT: { target: "connecting", actions: ["startChat"] }
        }
      },
      connecting: {
        on: {
          CHAT_STARTED: "chatActive",
          CHAT_QUEUED: {
            target: "chatQueued",
            actions: ["queueChat"]
          },
          CHAT_ENDED: {
            target: "chatInactive",
            actions: ["chatEnded"]
          },
          END_CHAT: {
            target: "chatInactive",
            actions: ["endChat"]
          }
        }
      },
      chatQueued: {
        on: {
          CHAT_STARTED: "chatActive",
          CHAT_QUEUED: {
            actions: ["queueChat"]
          },
          CHAT_ENDED: {
            target: "chatInactive",
            actions: ["chatEnded"]
          },
          END_CHAT: {
            target: "chatInactive",
            actions: ["endChat"]
          }
        }
      },
      chatActive: {
        type: "parallel",
        states: {
          connectingAgent: {
            initial: "connectedToAnAgent",
            states: {
              connectedToAnAgent: {},
              connectingToAnAgent: {
                on: {
                  TRANSFER_REQUESTED_DONE: "connectedToAnAgent"
                }
              }
            }
          },
          participantTyping: {
            initial: "agentIsNotTyping",
            states: {
              agentIsTyping: {
                on: {
                  AGENT_STOPS_TYPING: "agentIsNotTyping"
                }
              },
              agentIsNotTyping: {
                on: {
                  AGENT_STARTS_TYPING: "agentIsTyping"
                }
              }
            }
          },
          userTyping: {
            initial: "userIsNotTyping",
            states: {
              userIsTyping: {
                on: {
                  USER_STOPS_TYPING: "userIsNotTyping"
                },
                // Automatically triggers this action when the machine enters this state
                entry: ["userStartsTyping"]
              },
              userIsNotTyping: {
                on: {
                  USER_STARTS_TYPING: "userIsTyping"
                },
                // Automatically triggers this action when the machine enters this state
                entry: ["userStopsTyping"]
              }
            }
          }
        },
        on: {
          CHAT_ENDED: {
            target: "chatInactive",
            actions: ["chatEnded"]
          },
          END_CHAT: {
            target: "chatInactive",
            actions: ["endChat"]
          },
          CLEAR_CHIPS: { actions: ["clearChips"] },
          CLEAR_MESSAGES: { actions: ["clearMessages"] },
          // Per requirements
          // Chips should always be cleared when a message is sent or received
          MESSAGE_RECEIVED: { actions: ["clearChips", "messageReceived"] },
          MESSAGE_SENT: { actions: ["clearChips", "messageSent"] },
          MESSAGE_FAILED: { actions: ["messageFailed"] },
          PARTICIPANT_JOINED: {
            target: "chatActive.connectingAgent.connectedToAnAgent",
            actions: ["participantJoined"]
          },
          PARTICIPANT_LEFT: { actions: ["participantLeft"] },
          TRANSFER_REQUESTED: {
            target: "chatActive.connectingAgent.connectingToAnAgent",
            actions: ["transferRequested"]
          },
          CHAT_QUEUED: {
            target: "chatQueued",
            actions: ["queueChat"]
          }
        }
      },
      chatInactive: {}
    }
  },
  {
    actions: {
      startChat: (context, event) => {
        const { config } = event;
        context.client.handleUserChatEvents({
          eventType: "StartChat" /* START_CHAT */,
          eventId: uuidv4(),
          config
        });
      },
      queueChat: (context, event) => {
        var _a, _b;
        const waitingRoomEvent = event.payload;
        context.queueTitle = (_a = waitingRoomEvent == null ? void 0 : waitingRoomEvent.title) != null ? _a : "";
        context.queueDescription = (_b = waitingRoomEvent == null ? void 0 : waitingRoomEvent.description) != null ? _b : "";
      },
      clearChips: (context) => {
        context.chips = [];
      },
      clearMessages: (context) => {
        context.messagingWindowEvents = [];
      },
      messageReceived: (context, event) => {
        const newMessage = event.payload;
        if ((newMessage == null ? void 0 : newMessage.message) || (newMessage == null ? void 0 : newMessage.attachments) || (newMessage == null ? void 0 : newMessage.card)) {
          context.messagingWindowEvents.push(newMessage);
        }
        if ((newMessage == null ? void 0 : newMessage.chips) && newMessage.chips.length > 0) {
          context.chips = newMessage.chips;
        }
      },
      messageSent: (context, event) => {
        var _a;
        const messageSentEvent = event;
        if ((_a = messageSentEvent.payload) == null ? void 0 : _a.chips) {
          context.messagingWindowEvents.push(__spreadProps(__spreadValues({}, messageSentEvent.payload), {
            message: messageSentEvent.payload.chips[0].label
          }));
        } else if (context.failedMessagesEventIds.includes(
          messageSentEvent.payload.eventId
        )) {
          const indexOfRetriedMessage = context.failedMessagesEventIds.indexOf(
            messageSentEvent.payload.eventId
          );
          context.failedMessagesEventIds.splice(indexOfRetriedMessage, 1);
          context.messagingWindowEvents = context.messagingWindowEvents.map(
            (messagingWindowEvent) => {
              if (messagingWindowEvent.eventId === messageSentEvent.payload.eventId) {
                return messageSentEvent.payload;
              }
              return messagingWindowEvent;
            }
          );
        } else {
          context.messagingWindowEvents.push(
            event.payload
          );
        }
        context.client.handleUserChatEvents(messageSentEvent.payload);
      },
      messageFailed: (context, event) => {
        var _a;
        const failedMessageId = (_a = event.payload) == null ? void 0 : _a.eventOriginId;
        if (failedMessageId) {
          context.failedMessagesEventIds.push(failedMessageId);
        }
      },
      participantJoined: (context, event) => {
        context.messagingWindowEvents.push(
          event.payload
        );
      },
      participantLeft: (context, event) => {
        context.messagingWindowEvents.push(
          event.payload
        );
      },
      transferRequested: (context, event) => {
        context.messagingWindowEvents.push(
          event.payload
        );
      },
      userStopsTyping: (context) => {
        context.client.handleUserChatEvents({
          eventType: "ParticipantTyping" /* PARTICIPANT_TYPING */,
          eventId: uuidv4(),
          isTyping: false
        });
      },
      userStartsTyping: (context) => {
        context.client.handleUserChatEvents({
          eventType: "ParticipantTyping" /* PARTICIPANT_TYPING */,
          eventId: uuidv4(),
          isTyping: true
        });
      },
      endChat: (context, event) => {
        context.client.handleUserChatEvents(
          event.payload
        );
      },
      chatEnded: (context, event) => {
        context.chatEndedReason = event.payload.reason;
      },
      errorReceived: (context, event) => {
        context.toastErrors.push(
          event.payload
        );
      },
      clearError: (context, event) => {
        context.toastErrors = context.toastErrors.filter(
          (error) => error.eventId !== event.payload.eventId
        );
      }
    }
  }
);

// src/components/live-chat-core/live-chat-core.component.tsx
import { useMachine } from "@xstate/react";
import { v4 as uuidv44 } from "uuid";

// src/components/live-chat/live-chat.component.tsx
import React15 from "react";
import { Box as Box13, Modal as Modal3, Spinner, styled as styled3 } from "@leagueplatform/genesis-core";

// src/components/chat-header/chat-header.component.tsx
import React from "react";
import { Box, HeadingText, Button } from "@leagueplatform/genesis-core";
import { useIntl } from "@leagueplatform/locales";
import {
  EVENT_NAME,
  PRODUCT_AREA,
  SUB_PRODUCT_AREA,
  trackAnalyticsEvent
} from "@leagueplatform/analytics";

// src/constants/chat-analytics.constants.ts
var LIVE_CHAT_ANALYTICS_SCREEN_NAME = "chat";

// src/components/chat-header/chat-header.component.tsx
function ChatHeader({
  title,
  setShowEndChatModal,
  hideEndChat,
  chatEnded
}) {
  const { formatMessage } = useIntl();
  const endChat = () => {
    setShowEndChatModal(true);
    trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA.GET_CARE,
      sub_product_area: SUB_PRODUCT_AREA.LIVE_CHAT,
      screen_name: LIVE_CHAT_ANALYTICS_SCREEN_NAME,
      detail: "end chat",
      chat_closed_by_agent: chatEnded
    });
  };
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      css: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "$oneAndHalf $one",
        borderBottom: "1px solid $onSurfaceBorderSubdued"
      }
    },
    /* @__PURE__ */ React.createElement(
      HeadingText,
      {
        level: "2",
        size: "xl",
        css: {
          color: "$onSurfaceTextPrimary"
        }
      },
      title
    ),
    !hideEndChat && /* @__PURE__ */ React.createElement(Button, { priority: "secondary", quiet: true, onClick: () => endChat() }, formatMessage({ id: "END_CHAT" }))
  );
}

// src/components/live-chat/live-chat.component.tsx
import { useIntl as useIntl8 } from "@leagueplatform/locales";

// src/components/chat-messages-grid/chat-messages-grid.component.tsx
import React9, { useEffect, useRef } from "react";
import { debounce } from "lodash";
import { Box as Box7 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl4 } from "@leagueplatform/locales";

// src/components/chat-message/agent-typing-bubble.component.tsx
import React4 from "react";
import { Box as Box3 } from "@leagueplatform/genesis-core";

// src/components/chat-message/chat-message-bubble.component.tsx
import React3 from "react";
import { Box as Box2, ParagraphText } from "@leagueplatform/genesis-core";

// src/components/chat-message/chat-message-text-with-inline-links.component.tsx
import React2 from "react";
import linkifyHtml from "linkify-html";
import { HtmlToReact } from "@leagueplatform/web-common";
import { styled } from "@leagueplatform/genesis-core";
import {
  EVENT_NAME as EVENT_NAME2,
  PRODUCT_AREA as PRODUCT_AREA2,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA2,
  trackAnalyticsEvent as trackAnalyticsEvent2
} from "@leagueplatform/analytics";
var StyledLink = styled("a", {
  "p > &": {
    color: "inherit"
  },
  textDecoration: "underline"
});
var ChatMessageTextWithInlineLinks = ({
  text
}) => {
  const linkifyOptions = {
    defaultProtocol: "https",
    attributes: {
      rel: "noopener noreferrer"
    }
  };
  const onLinkClick = () => {
    trackAnalyticsEvent2(EVENT_NAME2.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA2.GET_CARE,
      sub_product_area: SUB_PRODUCT_AREA2.LIVE_CHAT,
      screen_name: LIVE_CHAT_ANALYTICS_SCREEN_NAME,
      detail: "link clicked"
    });
  };
  const RichTextOptions = {
    a: {
      component: StyledLink,
      props: {
        target: "_blank",
        onClick: onLinkClick
      }
    }
  };
  return /* @__PURE__ */ React2.createElement(
    HtmlToReact,
    {
      htmlString: linkifyHtml(text, linkifyOptions),
      options: RichTextOptions
    }
  );
};

// src/components/chat-message/chat-message-bubble.component.tsx
var ChatMessageBubble = ({
  backgroundColor,
  color,
  message,
  eventFromCurrentUser
}) => /* @__PURE__ */ React3.createElement(
  Box2,
  {
    css: __spreadValues({
      width: "100%",
      borderRadius: "$extraLarge",
      paddingTop: "$quarter",
      paddingBottom: "$quarter",
      display: "flex"
    }, eventFromCurrentUser && { justifyContent: "flex-end" })
  },
  /* @__PURE__ */ React3.createElement(
    Box2,
    {
      role: "gridcell",
      css: {
        backgroundColor: `${backgroundColor}`,
        borderRadius: "$extraLarge",
        padding: "$threeQuarters",
        width: "fit-content",
        maxWidth: "70%"
      }
    },
    /* @__PURE__ */ React3.createElement(
      ParagraphText,
      {
        css: {
          wordBreak: "break-word",
          color
        }
      },
      message && /* @__PURE__ */ React3.createElement(ChatMessageTextWithInlineLinks, { text: message })
    )
  )
);

// src/components/chat-message/agent-typing-bubble.component.tsx
var AgentTypingBubble = () => /* @__PURE__ */ React4.createElement(
  Box3,
  {
    "aria-hidden": true,
    role: "row",
    css: {
      marginBottom: "$one"
    }
  },
  /* @__PURE__ */ React4.createElement(
    Box3,
    {
      css: {
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "flex-start"
      }
    },
    /* @__PURE__ */ React4.createElement(
      Box3,
      {
        css: {
          flexDirection: "column",
          alignItems: "flex-start",
          width: "100%",
          marginLeft: "$twoAndHalf"
        }
      },
      /* @__PURE__ */ React4.createElement(
        ChatMessageBubble,
        {
          backgroundColor: "$surfaceBackgroundTertiary",
          color: "$onSurfaceTextPrimary",
          message: "..."
        }
      )
    )
  )
);

// src/components/system-message/system-message.component.tsx
import React5 from "react";
import {
  Box as Box4,
  ParagraphText as ParagraphText2,
  styled as styled2
} from "@leagueplatform/genesis-core";
var Line = styled2(Box4, {
  flex: 1,
  borderTop: "1px solid $onSurfaceBorderDefault",
  minWidth: "$one"
});
var SystemMessage = ({
  text,
  secondaryText,
  emphasis
}) => /* @__PURE__ */ React5.createElement(
  Box4,
  {
    css: {
      display: "flex",
      alignItems: "center",
      marginBottom: "$one"
    }
  },
  /* @__PURE__ */ React5.createElement(Line, null),
  /* @__PURE__ */ React5.createElement(
    Box4,
    {
      css: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "$half"
      }
    },
    /* @__PURE__ */ React5.createElement(
      ParagraphText2,
      {
        size: "sm",
        emphasis,
        css: {
          padding: "0 $half",
          margin: "0 !important",
          textAlign: "center",
          typography: emphasis === "subtle" ? "$bodyTwo" : "$subtitleTwo"
        }
      },
      text
    ),
    secondaryText && /* @__PURE__ */ React5.createElement(
      ParagraphText2,
      {
        size: "sm",
        emphasis,
        css: {
          padding: "0 $half",
          margin: "0 !important",
          textAlign: "center",
          typography: emphasis === "subtle" ? "$bodyTwo" : "$subtitleTwo"
        }
      },
      secondaryText
    )
  ),
  /* @__PURE__ */ React5.createElement(Line, null)
);

// src/components/chat-message/chat-message.component.tsx
import React8 from "react";
import { useIntl as useIntl3 } from "@leagueplatform/locales";
import { Box as Box6, UtilityText } from "@leagueplatform/genesis-core";
import { Avatar } from "@leagueplatform/web-common-components";
import { handleStaticAsset } from "@leagueplatform/asset-config";

// src/components/chat-message/chat-message-card.component.tsx
import React6 from "react";
import {
  Card,
  Button as Button2,
  HeadingText as HeadingText2,
  Box as Box5,
  ParagraphText as ParagraphText3
} from "@leagueplatform/genesis-core";

// src/constants/chat-message.constants.ts
var CHAT_MESSAGE_CARD_MAX_WIDTH = 373;

// src/components/chat-message/chat-message-card.component.tsx
import {
  EVENT_NAME as EVENT_NAME3,
  PRODUCT_AREA as PRODUCT_AREA3,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA3,
  trackAnalyticsEvent as trackAnalyticsEvent3
} from "@leagueplatform/analytics";
var ChatMessageCard = ({
  title,
  subtitle,
  buttons
}) => {
  const urlRegex = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(:\d+)?(\/\S*)?$/;
  const openCardLink = (urlString) => {
    if (!urlString)
      return;
    const url = /^https?:\/\//i.test(urlString) ? urlString : `https://${urlString}`;
    window.open(url, "_blank");
    trackAnalyticsEvent3(EVENT_NAME3.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA3.GET_CARE,
      sub_product_area: SUB_PRODUCT_AREA3.LIVE_CHAT,
      screen_name: LIVE_CHAT_ANALYTICS_SCREEN_NAME,
      detail: "message card clicked"
    });
  };
  const validButtons = buttons.filter(
    (button) => button.value && urlRegex.test(button.value)
  );
  return /* @__PURE__ */ React6.createElement(
    Card.Elevated,
    {
      css: {
        maxWidth: `${CHAT_MESSAGE_CARD_MAX_WIDTH}px`,
        flexBasis: `${CHAT_MESSAGE_CARD_MAX_WIDTH}px`,
        flex: 1
      }
    },
    /* @__PURE__ */ React6.createElement(Card.Section, { padding: "$one" }, /* @__PURE__ */ React6.createElement(HeadingText2, { size: "md", level: "4" }, title)),
    subtitle && /* @__PURE__ */ React6.createElement(Card.Section, { padding: "$one" }, /* @__PURE__ */ React6.createElement(ParagraphText3, { emphasis: "subtle" }, subtitle)),
    /* @__PURE__ */ React6.createElement(Card.Section, { padding: "$one" }, /* @__PURE__ */ React6.createElement(
      Box5,
      {
        css: {
          display: "flex",
          justifyContent: "flex-start",
          gap: "$half"
        }
      },
      validButtons.map((button, i) => {
        const key = `${button.label}-${button.value}-${i}`;
        return /* @__PURE__ */ React6.createElement(
          Button2,
          {
            key,
            onClick: () => openCardLink(button.value),
            width: "fillContainer",
            size: "medium"
          },
          button.label
        );
      })
    ))
  );
};

// src/components/chat-message/message-failure-modal.component.tsx
import React7 from "react";
import {
  Modal,
  Button as Button3,
  ParagraphText as ParagraphText4,
  HeadingText as HeadingText3
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl2 } from "@leagueplatform/locales";
var MessageFailureModal = ({
  handleRetry
}) => {
  const { formatMessage } = useIntl2();
  return /* @__PURE__ */ React7.createElement(Modal.Root, null, /* @__PURE__ */ React7.createElement(Modal.Trigger, null, /* @__PURE__ */ React7.createElement(
    Button3,
    {
      hideLabel: true,
      destructive: true,
      quiet: true,
      priority: "secondary",
      icon: "statusAlert",
      size: "large"
    },
    formatMessage({ id: "LIVE_CHAT_RESEND_MESSAGE" })
  )), /* @__PURE__ */ React7.createElement(Modal.Content, null, /* @__PURE__ */ React7.createElement(Modal.Title, null, /* @__PURE__ */ React7.createElement(HeadingText3, { size: "sm", level: "2", css: { textAlign: "center" } }, formatMessage({ id: "LIVE_CHAT_MESSAGE_FAILED_TITLE" }))), /* @__PURE__ */ React7.createElement(ParagraphText4, { css: { textAlign: "center", marginTop: "$one" } }, formatMessage({ id: "LIVE_CHAT_MESSAGE_FAILED_BODY" })), /* @__PURE__ */ React7.createElement(
    Button3,
    {
      size: "medium",
      css: { display: "block", width: "100%", marginTop: "$one" },
      onClick: handleRetry
    },
    formatMessage({ id: "TRY_AGAIN" })
  ), /* @__PURE__ */ React7.createElement(Modal.Close, null, /* @__PURE__ */ React7.createElement(
    Button3,
    {
      priority: "secondary",
      size: "medium",
      quiet: true,
      css: {
        width: "100%",
        display: "block",
        marginTop: "$threeQuarters"
      }
    },
    formatMessage({ id: "RETURN_TO_CHAT" })
  ))));
};

// src/components/chat-message/chat-message.component.tsx
var ChatMessageFromCurrentUser = ({
  message,
  messageFailed,
  time,
  eventId,
  sendUserEvent,
  sender,
  userId
}) => {
  const { formatMessage } = useIntl3();
  return /* @__PURE__ */ React8.createElement(
    Box6,
    {
      role: "row",
      css: {
        marginBottom: "$one"
      }
    },
    /* @__PURE__ */ React8.createElement(
      Box6,
      {
        css: {
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "flex-start"
        }
      },
      /* @__PURE__ */ React8.createElement(
        Box6,
        {
          css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            width: "100%"
          }
        },
        /* @__PURE__ */ React8.createElement(
          ChatMessageBubble,
          {
            backgroundColor: "$primaryBackgroundDefault",
            color: "$onSurfaceTextReversed",
            message,
            eventFromCurrentUser: true
          }
        ),
        /* @__PURE__ */ React8.createElement(
          UtilityText,
          {
            size: "xs",
            css: {
              marginLeft: "$twoAndHalf",
              color: "$onSurfaceTextSubdued"
            }
          },
          messageFailed ? formatMessage({ id: "LIVE_CHAT_DELIVERY_FAILURE" }) : time
        )
      ),
      messageFailed && /* @__PURE__ */ React8.createElement(
        MessageFailureModal,
        {
          handleRetry: () => sendUserEvent({
            eventId,
            eventType: "Message" /* MESSAGE */,
            message,
            sender: {
              name: sender.name,
              id: userId
            },
            timestamp: /* @__PURE__ */ new Date()
          })
        }
      )
    )
  );
};
var ChatMessageFromOtherUser = ({
  message,
  card,
  sender,
  time
}) => {
  const avatar2 = handleStaticAsset(
    "LIVE_CHAT_AVATAR" /* LIVE_CHAT_AVATAR */
  );
  return /* @__PURE__ */ React8.createElement(
    Box6,
    {
      role: "row",
      css: {
        marginBottom: "$one"
      }
    },
    /* @__PURE__ */ React8.createElement(
      Box6,
      {
        css: {
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "flex-start"
        }
      },
      /* @__PURE__ */ React8.createElement(
        Box6,
        {
          css: {
            width: "$two",
            marginRight: "$half",
            marginBottom: "$quarter"
          }
        },
        !card && /* @__PURE__ */ React8.createElement(
          Avatar,
          {
            imageSrc: sender.avatarUrl || avatar2,
            width: "two",
            height: "two",
            fontSize: "caption"
          }
        )
      ),
      card ? /* @__PURE__ */ React8.createElement(
        ChatMessageCard,
        {
          title: card.title,
          subtitle: card == null ? void 0 : card.subtitle,
          buttons: card.buttons
        }
      ) : /* @__PURE__ */ React8.createElement(
        Box6,
        {
          css: {
            flexDirection: "column",
            alignItems: "flex-start",
            width: "100%"
          }
        },
        /* @__PURE__ */ React8.createElement(
          UtilityText,
          {
            size: "xs",
            css: {
              color: "$onSurfaceTextSubdued"
            }
          },
          sender.name
        ),
        /* @__PURE__ */ React8.createElement(
          ChatMessageBubble,
          {
            backgroundColor: "$surfaceBackgroundTertiary",
            color: "$onSurfaceTextPrimary",
            message
          }
        )
      )
    ),
    /* @__PURE__ */ React8.createElement(
      UtilityText,
      {
        size: "xs",
        css: {
          marginLeft: "$twoAndHalf",
          color: "$onSurfaceTextSubdued"
        }
      },
      time
    )
  );
};
var ChatMessage = ({
  fromCurrentUser,
  messageFailed,
  message,
  card,
  time,
  userId,
  sendUserEvent,
  eventId,
  sender
}) => fromCurrentUser ? /* @__PURE__ */ React8.createElement(
  ChatMessageFromCurrentUser,
  {
    message,
    time,
    messageFailed,
    sendUserEvent,
    sender,
    userId,
    eventId
  }
) : /* @__PURE__ */ React8.createElement(
  ChatMessageFromOtherUser,
  {
    message,
    card,
    time,
    sender
  }
);

// src/components/chat-messages-grid/chat-messages-grid.component.tsx
var handleScroll = debounce((boxRef) => {
  if (boxRef == null ? void 0 : boxRef.current) {
    boxRef.current.scrollTo({
      top: boxRef.current.scrollHeight,
      behavior: "smooth"
    });
  }
}, 250);
var ChatMessagesGrid = ({
  events,
  userId,
  agentIsTyping,
  connectingToAnAgent,
  failedEvents,
  queueData,
  sendUserEvent
}) => {
  const { formatMessage, formatTime } = useIntl4();
  const containerRef = useRef(null);
  useEffect(() => {
    handleScroll(containerRef);
  }, [events, agentIsTyping, connectingToAnAgent, queueData]);
  return /* @__PURE__ */ React9.createElement(
    Box7,
    {
      ref: containerRef,
      role: "grid",
      "aria-label": formatMessage({ id: "CHATS_IN_CONVERSATION" }),
      css: {
        flexGrow: "1",
        overflowY: "auto",
        padding: "$two $oneAndHalf",
        display: "flex",
        flexDirection: "column"
      }
    },
    events == null ? void 0 : events.map((data) => {
      var _a, _b;
      let messageFailed = -1;
      if (failedEvents) {
        messageFailed = failedEvents.findIndex(
          (failedEventId) => failedEventId === data.eventId
        );
      }
      return /* @__PURE__ */ React9.createElement(Box7, { key: data.eventId }, data.eventType === "Message" /* MESSAGE */ && /* @__PURE__ */ React9.createElement(
        ChatMessage,
        {
          fromCurrentUser: data.sender.id === userId,
          messageFailed: messageFailed > -1,
          eventId: data.eventId,
          sendUserEvent,
          userId,
          message: (data == null ? void 0 : data.message) || "",
          card: data.card,
          time: formatTime(data.timestamp),
          sender: data.sender
        }
      ), data.eventType === "ParticipantJoined" /* PARTICIPANT_JOINED */ && /* @__PURE__ */ React9.createElement(
        SystemMessage,
        {
          text: formatMessage(
            { id: "USERNAME_HAS_JOINED_THE_CHAT" },
            { username: (_a = data == null ? void 0 : data.participant) == null ? void 0 : _a.name }
          )
        }
      ), data.eventType === "ParticipantLeft" /* PARTICIPANT_LEFT */ && /* @__PURE__ */ React9.createElement(
        SystemMessage,
        {
          text: formatMessage(
            { id: "USERNAME_HAS_LEFT_THE_CHAT" },
            { username: (_b = data == null ? void 0 : data.participant) == null ? void 0 : _b.name }
          )
        }
      ));
    }),
    agentIsTyping && /* @__PURE__ */ React9.createElement(AgentTypingBubble, null),
    connectingToAnAgent && /* @__PURE__ */ React9.createElement(
      SystemMessage,
      {
        text: formatMessage({ id: "CONNECTING_YOU_WITH_AN_AGENT" }),
        emphasis: "subtle"
      }
    ),
    queueData && /* @__PURE__ */ React9.createElement(
      SystemMessage,
      {
        text: queueData.queueTitle,
        secondaryText: queueData.queueDescription,
        emphasis: "subtle"
      }
    )
  );
};

// src/components/chat-form/chat-form.component.tsx
import React12, { useEffect as useEffect3, useState } from "react";
import {
  Box as Box10,
  Button as Button5,
  InputStatusMessage,
  ParagraphText as ParagraphText5
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl5 } from "@leagueplatform/locales";
import { v4 as uuidv42 } from "uuid";

// src/components/chat-message/chat-message-chips.component.tsx
import React10 from "react";
import { Box as Box8, Button as Button4 } from "@leagueplatform/genesis-core";
var ChatMessageChips = ({
  chips,
  sendMessage
}) => /* @__PURE__ */ React10.createElement(
  Box8,
  {
    css: {
      display: "flex",
      flexWrap: "wrap",
      paddingBottom: "$two"
    }
  },
  chips == null ? void 0 : chips.map(
    (chip) => chip.link ? /* @__PURE__ */ React10.createElement(
      Button4,
      {
        key: chip.label,
        as: "a",
        href: chip.link.value,
        priority: "secondary",
        size: "medium",
        target: "_blank",
        rel: "noreferrer noopener",
        indicator: "externalLink",
        css: {
          margin: "$quarter"
        }
      },
      chip.label
    ) : /* @__PURE__ */ React10.createElement(
      Button4,
      {
        key: chip.label,
        priority: "secondary",
        size: "medium",
        css: {
          margin: "$quarter"
        },
        onClick: () => sendMessage(chip)
      },
      chip.label
    )
  )
);

// src/hooks/use-get-live-chat-config.hook.ts
import { useQuery } from "react-query";
import {
  getLiveChatConfig,
  LIVE_CHAT_CONFIG_PATH
} from "@leagueplatform/live-chat-api";
var useGetLiveChatConfig = (options) => useQuery(
  [LIVE_CHAT_CONFIG_PATH],
  () => getLiveChatConfig(),
  __spreadValues({
    staleTime: Infinity
  }, options)
);

// src/hooks/use-get-message-max-size.hook.ts
var useGetMessageMaxSize = () => useGetLiveChatConfig({
  select: (data) => data.data.find(
    (config) => {
      var _a;
      return ((_a = config == null ? void 0 : config.attributes) == null ? void 0 : _a.name) === "MESSAGE_MAX_SIZE";
    }
  )
});

// src/components/chat-form/chat-form.component.tsx
import {
  EVENT_NAME as EVENT_NAME4,
  PRODUCT_AREA as PRODUCT_AREA4,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA4,
  trackAnalyticsEvent as trackAnalyticsEvent4
} from "@leagueplatform/analytics";

// src/components/chat-form/autoresize-textarea.component.tsx
import React11, { useEffect as useEffect2 } from "react";
import { Textarea } from "@leagueplatform/genesis-commons";
import { Box as Box9 } from "@leagueplatform/genesis-core";
var TEXTAREA_MAX_HEIGHT = 150;
var useAutosizeTextArea = (textAreaRef, value) => {
  useEffect2(() => {
    if (textAreaRef) {
      textAreaRef.style.height = "0px";
      const { scrollHeight } = textAreaRef;
      textAreaRef.style.height = `${Math.min(
        scrollHeight + 2,
        TEXTAREA_MAX_HEIGHT
      )}px`;
    }
  }, [textAreaRef, value]);
};
var AutoResizeTextarea = ({
  id,
  textareaName,
  ariaDescribedby,
  textAreaRef,
  onChange,
  ariaLabel
}) => {
  var _a;
  useAutosizeTextArea(textAreaRef.current, (_a = textAreaRef.current) == null ? void 0 : _a.value);
  return /* @__PURE__ */ React11.createElement(
    Box9,
    {
      css: {
        flexBasis: "70%",
        flexGrow: 1,
        flexShrink: 0
      }
    },
    /* @__PURE__ */ React11.createElement(
      Textarea,
      {
        name: textareaName,
        id,
        rows: 1,
        minHeight: "40px",
        borderRadius: "medium",
        resize: "none",
        ref: textAreaRef,
        autoFocus: true,
        "aria-describedby": ariaDescribedby,
        "aria-label": ariaLabel,
        onChange
      }
    )
  );
};

// src/components/chat-form/chat-form.component.tsx
var ChatForm = ({
  userChatFormEvents,
  userName,
  userId,
  chipsData,
  chatEnded,
  inWaitingRoom
}) => {
  const { formatMessage } = useIntl5();
  const { data: messageMaxSize } = useGetMessageMaxSize();
  const characterLimit = Number(messageMaxSize == null ? void 0 : messageMaxSize.attributes.value);
  const [newMessage, setNewMessage] = useState("");
  useEffect3(() => {
    userChatFormEvents({
      eventId: uuidv42(),
      eventType: "ParticipantTyping" /* PARTICIPANT_TYPING */,
      isTyping: newMessage !== ""
    });
  }, [userChatFormEvents, newMessage]);
  const textAreaRef = React12.useRef(null);
  const handleChange = (e) => {
    setNewMessage(e.target.value);
  };
  const generateMessageEvent = (messageValue) => __spreadProps(__spreadValues({
    eventType: "Message" /* MESSAGE */,
    eventId: uuidv42(),
    timestamp: /* @__PURE__ */ new Date()
  }, messageValue), {
    sender: {
      id: userId,
      name: userName
    }
  });
  const handleSend = () => {
    const messageEvent = generateMessageEvent({ message: newMessage });
    userChatFormEvents(messageEvent);
    setNewMessage("");
    if (textAreaRef.current) {
      textAreaRef.current.value = "";
    }
    trackAnalyticsEvent4(EVENT_NAME4.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA4.GET_CARE,
      sub_product_area: SUB_PRODUCT_AREA4.LIVE_CHAT,
      screen_name: LIVE_CHAT_ANALYTICS_SCREEN_NAME,
      detail: "send"
    });
  };
  const sendMessage = (chip) => {
    const messageEvent = generateMessageEvent({ chips: [chip] });
    userChatFormEvents(messageEvent);
    trackAnalyticsEvent4(EVENT_NAME4.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA4.GET_CARE,
      sub_product_area: SUB_PRODUCT_AREA4.LIVE_CHAT,
      screen_name: LIVE_CHAT_ANALYTICS_SCREEN_NAME,
      detail: "suggestion chip clicked"
    });
  };
  const hasExceededLimit = !!characterLimit && newMessage.length > characterLimit;
  const isMessageEmpty = newMessage.length <= 0;
  if (chatEnded) {
    return /* @__PURE__ */ React12.createElement(Box10, null, /* @__PURE__ */ React12.createElement(
      ParagraphText5,
      {
        size: "sm",
        css: {
          textAlign: "center",
          typography: "$subtitleOne",
          color: "$onSurfaceTextCritical",
          marginBottom: "$two"
        }
      },
      formatMessage({ id: "CHAT_CLOSED" })
    ));
  }
  return /* @__PURE__ */ React12.createElement(Box10, { css: { padding: "$oneAndHalf" } }, chipsData.length > 0 && /* @__PURE__ */ React12.createElement(ChatMessageChips, { chips: chipsData, sendMessage }), /* @__PURE__ */ React12.createElement(
    Box10,
    {
      css: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-end",
        gap: "$half"
      }
    },
    /* @__PURE__ */ React12.createElement(
      AutoResizeTextarea,
      {
        id: "chat-message-input",
        textareaName: formatMessage({ id: "CHAT_MESSAGE_INPUT" }),
        textAreaRef,
        onChange: handleChange,
        ariaLabel: formatMessage({ id: "CHAT_MESSAGE_INPUT" }),
        ariaDescribedby: hasExceededLimit ? "errorMessage" : void 0
      }
    ),
    /* @__PURE__ */ React12.createElement(
      Button5,
      {
        disabled: isMessageEmpty || hasExceededLimit || inWaitingRoom,
        onClick: () => handleSend()
      },
      formatMessage({ id: "SEND" })
    )
  ), hasExceededLimit && /* @__PURE__ */ React12.createElement(InputStatusMessage, { inputStatus: "error", id: "errorMessage" }, formatMessage(
    { id: "LIVE_CHAT_CHARACTER_LIMIT" },
    {
      characterLimit
    }
  )));
};

// src/components/live-chat/live-chat.component.tsx
import { useGetUserProfile } from "@leagueplatform/web-common";
import { v4 as uuidv43 } from "uuid";
import { ErrorState } from "@leagueplatform/web-common-components";
import { useHistory as useHistory2 } from "@leagueplatform/routing";
import {
  EVENT_NAME as EVENT_NAME6,
  PRODUCT_AREA as PRODUCT_AREA6,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA6,
  trackAnalyticsEvent as trackAnalyticsEvent6
} from "@leagueplatform/analytics";

// src/components/live-chat-error-toast/live-chat-error-toast.component.tsx
import React13 from "react";
import { Box as Box11, ParagraphText as ParagraphText6, StatusBanner } from "@leagueplatform/genesis-core";
import { useIntl as useIntl6 } from "@leagueplatform/locales";
function LiveChatErrorToast({
  toastErrors,
  clearToastError
}) {
  const { formatMessage } = useIntl6();
  const title = formatMessage({ id: "LIVE_CHAT_GENERIC_TOAST_ERROR_TITLE" });
  return /* @__PURE__ */ React13.createElement(Box11, { css: { position: "relative" } }, toastErrors.map((toastError) => {
    var _a, _b;
    const description = (_b = (_a = toastError.errorType) == null ? void 0 : _a.message) != null ? _b : formatMessage({ id: "LIVE_CHAT_GENERIC_TOAST_ERROR_DESCRIPTION" });
    return /* @__PURE__ */ React13.createElement(
      StatusBanner,
      {
        key: toastError.eventId,
        icon: "statusInformationCircleFill",
        onDismissClick: () => clearToastError(toastError.eventId),
        status: "error",
        title,
        css: {
          position: "absolute",
          bottom: "$one",
          right: "$oneAndHalf",
          maxWidth: "50%",
          "@mobile": {
            maxWidth: "100%",
            bottom: "0",
            right: "0"
          }
        }
      },
      /* @__PURE__ */ React13.createElement(
        ParagraphText6,
        {
          emphasis: "subtle",
          css: {
            typography: "$bodyTwo",
            color: "$onSurfaceTextPrimary"
          }
        },
        description
      )
    );
  }));
}

// src/components/end-chat-modal-content/end-chat-modal-content.component.tsx
import React14, { useEffect as useEffect4 } from "react";
import {
  Box as Box12,
  HeadingText as HeadingText4,
  Button as Button6,
  Modal as Modal2,
  HeadingBar,
  ParagraphText as ParagraphText7
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl7 } from "@leagueplatform/locales";
import {
  EVENT_NAME as EVENT_NAME5,
  PRODUCT_AREA as PRODUCT_AREA5,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA5,
  trackAnalyticsEvent as trackAnalyticsEvent5
} from "@leagueplatform/analytics";
function EndChatModalContent({
  onChatEnd,
  onCancel
}) {
  const { formatMessage } = useIntl7();
  useEffect4(() => {
    trackAnalyticsEvent5(EVENT_NAME5.SCREEN_LOADED, {
      product_area: PRODUCT_AREA5.GET_CARE,
      sub_product_area: SUB_PRODUCT_AREA5.LIVE_CHAT,
      screen_name: "end chat pop up"
    });
  }, []);
  return /* @__PURE__ */ React14.createElement(
    Modal2.Content,
    {
      onInteractOutside: onCancel,
      showCloseButton: false,
      padding: "$none",
      width: { "@initial": 384 }
    },
    /* @__PURE__ */ React14.createElement(
      HeadingBar,
      {
        title: /* @__PURE__ */ React14.createElement(Modal2.Title, null, /* @__PURE__ */ React14.createElement(HeadingText4, { level: "5", size: "sm" }, formatMessage({ id: "END_CHAT" })))
      }
    ),
    /* @__PURE__ */ React14.createElement(
      Box12,
      {
        css: {
          padding: "$threeQuarters $one"
        }
      },
      /* @__PURE__ */ React14.createElement(Modal2.Description, null, /* @__PURE__ */ React14.createElement(
        ParagraphText7,
        {
          emphasis: "subtle",
          size: "sm",
          css: { textAlign: "center" }
        },
        formatMessage({ id: "END_CHAT_MODAL_DESCRIPTION" })
      )),
      /* @__PURE__ */ React14.createElement(Modal2.Close, null, /* @__PURE__ */ React14.createElement(
        Button6,
        {
          destructive: true,
          width: "fillContainer",
          css: { marginTop: "$oneAndHalf" },
          onClick: onChatEnd
        },
        formatMessage({ id: "END_CHAT" })
      )),
      /* @__PURE__ */ React14.createElement(Modal2.Close, null, /* @__PURE__ */ React14.createElement(
        Button6,
        {
          width: "fillContainer",
          quiet: true,
          priority: "secondary",
          css: { marginTop: "$half" },
          onClick: onCancel
        },
        formatMessage({ id: "RETURN_TO_CHAT" })
      ))
    )
  );
}

// src/hooks/use-live-chat-end-chat.hook.ts
import { useEffect as useEffect5, useState as useState2 } from "react";
import { useHistory } from "@leagueplatform/routing";
var useLiveChatEndChat = ({
  disableModal
}) => {
  const [showEndChatModal, setShowEndChatModal] = useState2(false);
  const [nextLocation, setNextLocation] = useState2("");
  const history = useHistory();
  useEffect5(() => {
    let unblock = () => {
    };
    if (!disableModal) {
      unblock = history.block((location) => {
        setShowEndChatModal(true);
        setNextLocation(location.pathname);
        return false;
      });
    }
    return () => {
      unblock();
    };
  }, [history, disableModal]);
  const onConfirmNavigation = () => {
    setShowEndChatModal(false);
    history.block(() => {
    });
    if (nextLocation) {
      history.push(nextLocation);
    } else {
      history.goBack();
    }
  };
  const onCancelNavigation = () => {
    setNextLocation("");
    setShowEndChatModal(false);
  };
  return {
    showEndChatModal,
    setShowEndChatModal,
    onCancelNavigation,
    onConfirmNavigation
  };
};

// src/components/live-chat/live-chat.component.tsx
var Wrapper = styled3(Box13, {
  backgroundColor: "$surfaceBackgroundTertiary",
  display: "flex",
  justifyContent: "center",
  inset: 0,
  position: "absolute",
  overflowX: "hidden"
});
var MessageWindow = styled3(Box13, {
  backgroundColor: "$surfaceBackgroundPrimary",
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: "668px"
});
var ErrorWrapper = styled3(Box13, {
  display: "flex",
  flex: 1,
  justifyContent: "center",
  padding: "0 $five",
  "@mobile": {
    padding: "0 $one"
  }
});
var UIEvents = [
  "Message" /* MESSAGE */,
  "ParticipantJoined" /* PARTICIPANT_JOINED */,
  "ParticipantLeft" /* PARTICIPANT_LEFT */
];
var Loading = () => /* @__PURE__ */ React15.createElement(
  Box13,
  {
    css: {
      display: "flex",
      flexGrow: 1,
      justifyContent: "center",
      alignItems: "center",
      color: "$decorativeBrandPrimaryDefault"
    }
  },
  /* @__PURE__ */ React15.createElement(Spinner, { loading: true })
);
var LiveChat = ({
  chatLoading,
  events,
  chips,
  agentIsTyping,
  connectingToAnAgent,
  queueData,
  chatEnded,
  failedEvents,
  chatEndedReason,
  sendUserEvent,
  toastErrors,
  clearToastError
}) => {
  var _a, _b;
  const history = useHistory2();
  const { formatMessage } = useIntl8();
  const title = formatMessage({ id: "CHAT" });
  const { data: userProfileData } = useGetUserProfile();
  const userName = `${((_a = userProfileData == null ? void 0 : userProfileData.userProfile) == null ? void 0 : _a.firstName) || ""} ${((_b = userProfileData == null ? void 0 : userProfileData.userProfile) == null ? void 0 : _b.lastName) || ""}`;
  const userId = (userProfileData == null ? void 0 : userProfileData.userId) || "";
  const chatEvents = events.filter(
    (event) => UIEvents.includes(event.eventType)
  );
  const isChatUnavailable = chatEndedReason.type === "CHAT_UNAVAILABLE" /* CHAT_UNAVAILABLE */;
  const {
    showEndChatModal,
    setShowEndChatModal,
    onCancelNavigation,
    onConfirmNavigation
  } = useLiveChatEndChat({ disableModal: isChatUnavailable });
  const sendEndChatEvent = () => {
    sendUserEvent({
      eventType: "EndChat" /* END_CHAT */,
      eventId: uuidv43()
    });
    onConfirmNavigation();
    trackAnalyticsEvent6(EVENT_NAME6.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA6.GET_CARE,
      sub_product_area: SUB_PRODUCT_AREA6.LIVE_CHAT,
      screen_name: "end chat pop up",
      detail: formatMessage({ id: "END_CHAT" })
    });
  };
  const cancelNavigation = () => {
    onCancelNavigation();
    trackAnalyticsEvent6(EVENT_NAME6.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA6.GET_CARE,
      sub_product_area: SUB_PRODUCT_AREA6.LIVE_CHAT,
      screen_name: "end chat pop up",
      detail: formatMessage({ id: "RETURN_TO_CHAT" })
    });
  };
  return /* @__PURE__ */ React15.createElement(React15.Fragment, null, showEndChatModal && /* @__PURE__ */ React15.createElement(Modal3.Root, { defaultOpen: true }, /* @__PURE__ */ React15.createElement(
    EndChatModalContent,
    {
      onChatEnd: sendEndChatEvent,
      onCancel: cancelNavigation
    }
  )), /* @__PURE__ */ React15.createElement(Wrapper, null, /* @__PURE__ */ React15.createElement(MessageWindow, null, chatLoading ? /* @__PURE__ */ React15.createElement(Loading, null) : /* @__PURE__ */ React15.createElement(React15.Fragment, null, /* @__PURE__ */ React15.createElement(
    ChatHeader,
    {
      title,
      setShowEndChatModal,
      hideEndChat: isChatUnavailable,
      chatEnded
    }
  ), isChatUnavailable ? /* @__PURE__ */ React15.createElement(ErrorWrapper, null, /* @__PURE__ */ React15.createElement(
    ErrorState,
    {
      headingString: chatEndedReason.errorTitle || formatMessage({ id: "LIVE_CHAT_GENERIC_ERROR_TITLE" }),
      bodyString: chatEndedReason.errorMessage || formatMessage({
        id: "LIVE_CHAT_GENERIC_ERROR_DESCRIPTION"
      }),
      buttonId: "LIVE_CHAT_GENERIC_ERROR_BUTTON",
      onButtonClick: () => history.goBack()
    }
  )) : /* @__PURE__ */ React15.createElement(React15.Fragment, null, /* @__PURE__ */ React15.createElement(
    ChatMessagesGrid,
    __spreadValues({
      events: chatEvents,
      failedEvents,
      userId,
      agentIsTyping,
      connectingToAnAgent,
      sendUserEvent
    }, (queueData == null ? void 0 : queueData.isQueued) && { queueData })
  ), toastErrors.length > 0 && /* @__PURE__ */ React15.createElement(
    LiveChatErrorToast,
    {
      toastErrors,
      clearToastError
    }
  ), /* @__PURE__ */ React15.createElement(
    ChatForm,
    {
      userChatFormEvents: sendUserEvent,
      userName,
      userId,
      chipsData: chips,
      chatEnded,
      inWaitingRoom: queueData == null ? void 0 : queueData.isQueued
    }
  ))))));
};

// src/components/live-chat-core/live-chat-core.component.tsx
var LiveChatCore = ({ startChatConfig }) => {
  const { liveChatClient } = leagueLiveChat.getConfig();
  const [liveChatCurrent, sendLiveChatEvent] = useMachine(
    () => createLiveChatMachine(liveChatClient)
  );
  const { context: liveChatContext } = liveChatCurrent;
  const { subscribeToAgentChatEvents } = liveChatContext.client;
  useEffect6(() => {
    sendLiveChatEvent("START_CHAT", { config: startChatConfig || {} });
    return () => {
      sendLiveChatEvent("END_CHAT", {
        eventType: "EndChat" /* END_CHAT */,
        eventId: uuidv44()
      });
    };
  }, [startChatConfig, sendLiveChatEvent]);
  useEffect6(() => {
    subscribeToAgentChatEvents((event) => {
      switch (event.eventType) {
        case "ChatStarted" /* CHAT_STARTED */:
          sendLiveChatEvent("CHAT_STARTED");
          break;
        case "ParticipantTyping" /* PARTICIPANT_TYPING */:
          if (event.isTyping) {
            sendLiveChatEvent("AGENT_STARTS_TYPING");
            break;
          }
          sendLiveChatEvent("AGENT_STOPS_TYPING");
          break;
        case "ErrorReceived" /* ERROR_RECEIVED */:
          if (event.errorType.type === "MessageFailed" /* MESSAGE_FAILED */) {
            sendLiveChatEvent("MESSAGE_FAILED", {
              payload: event.errorType
            });
            break;
          }
          sendLiveChatEvent("ERROR_RECEIVED", { payload: event });
          break;
        case "WaitingRoom" /* WAITING_ROOM */:
          sendLiveChatEvent("CHAT_QUEUED", { payload: event });
          break;
        case "ParticipantJoined" /* PARTICIPANT_JOINED */:
          sendLiveChatEvent("PARTICIPANT_JOINED", { payload: event });
          break;
        case "ParticipantLeft" /* PARTICIPANT_LEFT */:
          sendLiveChatEvent("PARTICIPANT_LEFT", { payload: event });
          break;
        case "TransferRequested" /* TRANSFER_REQUESTED */:
          sendLiveChatEvent("TRANSFER_REQUESTED", { payload: event });
          break;
        case "Message" /* MESSAGE */:
          sendLiveChatEvent("MESSAGE_RECEIVED", { payload: event });
          break;
        case "ChatEnded" /* CHAT_ENDED */:
          sendLiveChatEvent("CHAT_ENDED", { payload: event });
          break;
        default:
      }
    });
  }, [sendLiveChatEvent, subscribeToAgentChatEvents]);
  const sendUserEvent = (event) => {
    switch (event.eventType) {
      case "Message" /* MESSAGE */:
        sendLiveChatEvent("MESSAGE_SENT", { payload: event });
        break;
      case "EndChat" /* END_CHAT */:
        sendLiveChatEvent("END_CHAT", { payload: event });
        break;
      case "ParticipantTyping" /* PARTICIPANT_TYPING */:
        if (event.isTyping) {
          sendLiveChatEvent("USER_STARTS_TYPING");
          break;
        }
        sendLiveChatEvent("USER_STOPS_TYPING");
        break;
      default:
        break;
    }
  };
  return /* @__PURE__ */ React16.createElement(
    LiveChat,
    {
      chatLoading: liveChatCurrent.matches("idle") || liveChatCurrent.matches("connecting"),
      events: liveChatContext.messagingWindowEvents,
      failedEvents: liveChatContext.failedMessagesEventIds,
      chips: liveChatContext.chips,
      agentIsTyping: liveChatCurrent.matches(
        "chatActive.participantTyping.agentIsTyping"
      ),
      connectingToAnAgent: liveChatCurrent.matches(
        "chatActive.connectingAgent.connectingToAnAgent"
      ),
      queueData: {
        isQueued: liveChatCurrent.matches("chatQueued"),
        queueTitle: liveChatContext.queueTitle,
        queueDescription: liveChatContext.queueDescription
      },
      chatEnded: liveChatCurrent.matches("chatInactive"),
      chatEndedReason: liveChatContext.chatEndedReason,
      sendUserEvent,
      toastErrors: liveChatContext.toastErrors,
      clearToastError: (eventId) => sendLiveChatEvent("CLEAR_ERROR", { payload: { eventId } })
    }
  );
};

// src/hooks/use-get-first-questionnaire-id-config.hook.ts
var useGetFirstQuestionnaireIdConfig = () => useGetLiveChatConfig({
  select: (data) => data.data.find(
    (config) => {
      var _a;
      return ((_a = config == null ? void 0 : config.attributes) == null ? void 0 : _a.name) === "FIRST_QUESTIONNAIRE_ID";
    }
  )
});

// src/hooks/use-live-chat-landing.hook.ts
import { postStartChat } from "@leagueplatform/live-chat-api";
import { useMutation } from "react-query";
var useLiveChatLanding = () => {
  var _a, _b, _c;
  const {
    data: firstQuestionnaireId,
    isLoading: firstQuestionnaireLoading,
    isError: firstQuestionnaireError
  } = useGetFirstQuestionnaireIdConfig();
  const {
    data,
    mutate: startChatWithQuestionnaireAnswers,
    isLoading: startChatLoading,
    isError: startChatError
  } = useMutation(
    (answers) => postStartChat(answers)
  );
  return {
    firstQuestionnaireId,
    startChatWithQuestionnaireAnswers,
    startChatResponse: (_c = (_b = (_a = data == null ? void 0 : data.data) == null ? void 0 : _a.attributes) == null ? void 0 : _b.configs) != null ? _c : {},
    isLoading: firstQuestionnaireLoading || startChatLoading,
    isError: firstQuestionnaireError || startChatError
  };
};

// src/pages/live-chat-landing.page.tsx
import { useHistory as useHistory3 } from "@leagueplatform/routing";
import { QuestionnaireFlow } from "@leagueplatform/fhir-questionnaire-flow";
import { useIntl as useIntl9 } from "@leagueplatform/locales";
import {
  EVENT_NAME as EVENT_NAME7,
  PRODUCT_AREA as PRODUCT_AREA7,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA7,
  trackAnalyticsEvent as trackAnalyticsEvent7
} from "@leagueplatform/analytics";
var LiveChatLanding = () => {
  const { formatMessage } = useIntl9();
  const history = useHistory3();
  const [isQuestionnaireDone, setIsQuestionnaireDone] = useState3(false);
  const questionnaireTitle = formatMessage({
    id: "LIVE_CHAT_LANDING_PAGE_TITLE"
  });
  useEffect7(() => {
    trackAnalyticsEvent7(EVENT_NAME7.SCREEN_LOADED, {
      product_area: PRODUCT_AREA7.GET_CARE,
      sub_product_area: SUB_PRODUCT_AREA7.LIVE_CHAT,
      screen_name: questionnaireTitle
    });
  }, [questionnaireTitle]);
  const {
    firstQuestionnaireId,
    startChatWithQuestionnaireAnswers,
    startChatResponse,
    isLoading,
    isError
  } = useLiveChatLanding();
  const handleClose = (title) => {
    trackAnalyticsEvent7(EVENT_NAME7.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA7.GET_CARE,
      sub_product_area: SUB_PRODUCT_AREA7.LIVE_CHAT,
      screen_name: title,
      detail: "exit questionnaire"
    });
    history.goBack();
  };
  const handleCompleted = (thread) => __async(void 0, null, function* () {
    var _a;
    const answers = (_a = thread.answers) != null ? _a : [];
    yield startChatWithQuestionnaireAnswers(answers);
    setIsQuestionnaireDone(true);
    trackAnalyticsEvent7(EVENT_NAME7.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA7.GET_CARE,
      sub_product_area: SUB_PRODUCT_AREA7.LIVE_CHAT,
      screen_name: questionnaireTitle,
      detail: formatMessage({ id: "QUESTIONNAIRE_FLOW_CONTINUE" })
    });
  });
  if (isLoading) {
    return /* @__PURE__ */ React17.createElement(
      Box14,
      {
        css: {
          display: "flex",
          position: "absolute",
          inset: 0,
          justifyContent: "center",
          alignItems: "center",
          color: "$decorativeBrandPrimaryDefault"
        }
      },
      /* @__PURE__ */ React17.createElement(Spinner2, { loading: true })
    );
  }
  if (isError) {
    return /* @__PURE__ */ React17.createElement(
      Box14,
      {
        css: {
          display: "flex",
          position: "absolute",
          inset: 0,
          justifyContent: "center",
          alignItems: "center",
          color: "$decorativeBrandPrimaryDefault"
        }
      },
      /* @__PURE__ */ React17.createElement(ErrorState2, { hideButton: true, headingId: "GENERIC_MESSAGING_ERROR" })
    );
  }
  return firstQuestionnaireId && !isQuestionnaireDone ? /* @__PURE__ */ React17.createElement(
    QuestionnaireFlow,
    {
      title: questionnaireTitle,
      firstQuestionnaireId: firstQuestionnaireId.attributes.value,
      onClose: handleClose,
      onCompleted: handleCompleted
    }
  ) : /* @__PURE__ */ React17.createElement(LiveChatCore, { startChatConfig: startChatResponse });
};

// src/live-chat.routes.tsx
var LiveChatRoutes = () => /* @__PURE__ */ React18.createElement(Switch, null, /* @__PURE__ */ React18.createElement(Route, { component: LiveChatLanding }));

// src/index.ts
initModule();
export {
  ChatEndedReasonTypes,
  ErrorTypes,
  EventTypes,
  LiveChatRoutes,
  leagueLiveChat
};
//# sourceMappingURL=index.js.map